export default function MobileInvestBar({ label, price, tone = "emerald" }) {
  const go = () => document.getElementById("invest-panel")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-obsidian/90 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden" data-testid="mobile-invest-bar">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-white">{label}</p>
          <p className="font-mono text-sm text-slate-400">{price}</p>
        </div>
        <button onClick={go} className={`${tone === "amber" ? "btn-gold" : "btn-primary"} shrink-0`} data-testid="mobile-invest-button">Invest</button>
      </div>
    </div>
  );
}
